import { render, staticRenderFns } from "./UidTokenLogin.vue?vue&type=template&id=2cf27f11&scoped=true&"
import script from "./UidTokenLogin.vue?vue&type=script&lang=js&"
export * from "./UidTokenLogin.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenLogin.vue?vue&type=style&index=0&id=2cf27f11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf27f11",
  null
  
)

export default component.exports